import React, { useState, useEffect } from "react";
import axios from "axios";
import commonData from "../../importanValue";

const TodayExams = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const { websiteId } = props.match.params;

  const handleDateChange = (event) => {
    const date = event.target.value;
    setSelectedDate(date);
    const searchParams = new URLSearchParams(props.location.search);
    searchParams.set("date", date);
    props.history.push({ search: searchParams.toString() });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const date = new URLSearchParams(props.location.search).get("date");
      const body = {
        type: "gettodaysexams",
        search: date ? date : new Date().toISOString().split("T")[0],
        qid: "",
      };

      try {
        const response = await axios.post(`${commonData.api}/support`, body);
        const transformedData = await transformData(response.data[0]);
        setData(transformedData);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props.location.search]);

  const transformData = (input) => {
    const packageMap = new Map();

    input.forEach((item) => {
      const {
        group_name,
        quiz_name,
        examdescription,
        whatsapplink,
        gid,
        bucket,
        quid,
        isNormalPackage,
      } = item;

      if (!packageMap.has(group_name)) {
        packageMap.set(group_name, {
          packageName: group_name,
          exams: [],
          whatsappGroup: whatsapplink,
          gid,
          bucket,
          isNormalPackage,
        });
      }

      packageMap.get(group_name).exams.push({
        title: quiz_name,
        syllabus: examdescription,
        quid: quid,
        isNormalPackage,
      });
    });

    return Array.from(packageMap.values());
  };

  // const handlePrint = () => {
  //   window.print();
  // };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .exam-grid {
            grid-template-columns: 1fr !important;
          }
          .cta-container {
            flex-direction: column !important;
          }
          .cta-link {
            max-width: 100% !important;
            min-width: auto !important;
          }
        }
        @media (min-width: 769px) {
          .exam-grid {
            grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)) !important;
          }
        }
        @media (min-width: 1024px) {
          .exam-grid {
            grid-template-columns: repeat(auto-fit, minmax(400px, 1fr)) !important;
          }
        }
        
        /* Print-specific styles to force desktop layout */
        @media print {
          body {
            margin: 0;
            padding: 0;
          }
          
          .exam-grid {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: wrap !important;
            gap: 15px !important;
            width: 100% !important;
            justify-content: flex-start !important;
            align-items: flex-start !important;
          }
          
          .exam-card {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
            -webkit-column-break-inside: avoid !important;
            flex: 0 0 calc(50% - 7.5px) !important;
            width: calc(50% - 7.5px) !important;
            max-width: calc(50% - 7.5px) !important;
            margin-bottom: 0 !important;
            box-sizing: border-box !important;
            display: flex !important;
            flex-direction: column !important;
          }
          
          .cta-container {
            display: flex !important;
            flex-direction: row !important;
            justify-content: center !important;
            gap: 15px !important;
            width: 100% !important;
            break-inside: avoid !important;
            page-break-inside: avoid !important;
            margin-top: 20px !important;
          }
          
          .cta-link {
            flex: 1 1 auto !important;
            max-width: 45% !important;
            min-width: 200px !important;
          }
          
          /* Ensure proper page breaks and spacing for print */
          .each-package-info {
            page-break-after: always !important;
            margin-bottom: 20px !important;
            width: 100% !important;
            box-sizing: border-box !important;
            break-inside: avoid !important;
            page-break-inside: avoid !important;
            display: block !important;
          }
          
          /* Force desktop-style container width */
          .print-container {
            max-width: none !important;
            width: 100% !important;
            padding: 20px !important;
          }
          
          /* Force print in color if possible */
          * {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          /* Prevent headers and content from breaking */
          h2, h3 {
            break-after: avoid !important;
            page-break-after: avoid !important;
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }
          
          /* Prevent package summary from breaking */
          .package-summary {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
            break-after: avoid !important;
            page-break-after: avoid !important;
          }
          
          /* Header image should not break */
          img {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }
          
          /* Date input and print button container */
          .date-print-container {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
            break-after: avoid !important;
            page-break-after: avoid !important;
          }
          
          /* Hide interactive elements and disable click functionality in print */
          .package-summary a {
            color: #ffd700 !important;
            text-decoration: underline !important;
          }
          
          .package-summary h3 {
            display: block !important;
          }
          
          /* Override any mobile-specific styles during print */
          @media (max-width: 768px) {
            .exam-grid {
              display: flex !important;
              flex-direction: row !important;
              flex-wrap: wrap !important;
              gap: 15px !important;
            }
            .exam-card {
              flex: 0 0 calc(50% - 7.5px) !important;
              width: calc(50% - 7.5px) !important;
              max-width: calc(50% - 7.5px) !important;
            }
            .cta-container {
              flex-direction: row !important;
            }
            .cta-link {
              max-width: 45% !important;
              min-width: 200px !important;
            }
          }
        }
      `}</style>
      <div
        style={{
          background: "linear-gradient(135deg, #1a1a1a, #2c2c2c)",
          minHeight: "100vh",
          padding: "0",
        }}
      >
        <div
          className="print-container"
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <div
            className="date-print-container"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              style={{
                marginBottom: "20px",
                backgroundColor: "#fff",
                color: "#000",
                border: "3px solid #ffd700",
                borderRadius: "6px",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "bold",
                width: "100%",
                maxWidth: "300px",
                boxSizing: "border-box",
              }}
            />
            <button
              onClick={handlePrint}
              style={{
                marginLeft: "10px",
                backgroundColor: "#ffd700",
                color: "#000",
                border: "2px solid #000",
                borderRadius: "6px",
                padding: "12px 20px",
                fontSize: "14px",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
              }}
            >
              Print
            </button>
          </div>
          <img
            src="https://bit.ly/3VWxb9V"
            alt="Main Header Banner"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "800px",
              display: "block",
              margin: "0 auto 20px auto",
              borderRadius: "8px",
              boxShadow: "0px 4px 8px rgba(255, 215, 0, 0.3)",
            }}
          />

          {/* Three Banner Links */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            {/* App Store Link Banner */}
            <a
              href="https://play.google.com/store/apps/details?id=com.navachaitanya.onlineexams&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: "100%",
                maxWidth: "400px",
                textDecoration: "none",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL || ""}/app-banner.jpg`}
                alt="Download App from Play Store"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(255, 215, 0, 0.3)",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              />
            </a>

            {/* YouTube Demo Banner */}
            <a
              href="https://youtu.be/-fKBvm3xh6Q"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: "100%",
                maxWidth: "400px",
                textDecoration: "none",
              }}
            >
              <img
                src={`${
                  process.env.PUBLIC_URL || ""
                }/exams-youtube-demo-banner.jpg`}
                alt="Watch YouTube Demo"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(255, 215, 0, 0.3)",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              />
            </a>

            {/* Active Packages Banner */}
            <a
              href="https://exams3.navachaitanya.net"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: "100%",
                maxWidth: "400px",
                textDecoration: "none",
              }}
            >
              <img
                src={`${
                  process.env.PUBLIC_URL || ""
                }/active-packages-banner.jpg`}
                alt="Visit Active Packages"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(255, 215, 0, 0.3)",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              />
            </a>
          </div>

          <div
            className="package-summary"
            style={{
              marginBottom: "20px",
              backgroundColor: "#000",
              color: "#fff",
              padding: "15px",
              borderRadius: "5px",
              boxShadow: "0px 2px 8px rgba(255, 215, 0, 0.4)",
              border: "2px solid #ffd700",
            }}
          >
            {/* <h3 style={{ 
              color: "white", 
              marginBottom: "10px",
              fontSize: "14px",
              lineHeight: "1.4"
            }}>
              మీ బ్యాచ్ పై క్లిక్ చేయడం ద్వారా మీ బ్యాచ్ కు సంబంధించిన ఎగ్జామ్
              సెక్షన్ కు జంప్ కావచ్చు
              <br />
              <span style={{ fontSize: "12px", color: "#ffd700", fontStyle: "italic" }}>
                (ఈ ఫీచర్ వెబ్‌సైట్ మరియు PDF రెండింటిలో పని చేస్తుంది)
              </span>
            </h3> */}
            <ul style={{ margin: 0, paddingLeft: "20px" }}>
              {data.map((packageData, index) => (
                <li
                  key={index}
                  style={{
                    color: "#ffd700",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "5px",
                    listStyleType: "disc",
                  }}
                >
                  <a
                    href={`#package-${index}`}
                    style={{
                      color: "#ffd700",
                      textDecoration: "none",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = "#fff";
                      e.target.style.textShadow = "0px 0px 8px #ffd700";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = "#ffd700";
                      e.target.style.textShadow = "none";
                    }}
                  >
                    {packageData.packageName}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {data.map((packageData, index) => (
            <div
              key={index}
              id={`package-${index}`}
              className="each-package-info"
              style={{
                marginBottom: "20px",
                backgroundColor: "#000",
                color: "#fff",
                padding: "15px",
                borderRadius: "5px",
                boxShadow: "0px 2px 8px rgba(255, 215, 0, 0.4)",
                pageBreakAfter: "always",
                border: "3px solid #ffd700",
                scrollMarginTop: "20px", // Add scroll margin for better positioning
              }}
            >
              <h2
                style={{
                  marginBottom: "10px",
                  color: "#ffd700",
                  fontWeight: "bold",
                  textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                }}
              >
                {packageData.packageName}
              </h2>
              <div>
                <div
                  className="exam-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    gap: "15px",
                  }}
                >
                  {packageData.exams.map((exam, i) => (
                    <div
                      key={i}
                      className="exam-card"
                      style={{
                        border: "2px solid #ffd700",
                        padding: "15px",
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "200px",
                      }}
                    >
                      <h3
                        style={{
                          color: "#000",
                          fontWeight: "bold",
                          fontSize: "16px",
                          marginBottom: "10px",
                          lineHeight: "1.4",
                          flex: "0 0 auto",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: `${i + 1}. ${exam.title}`,
                        }}
                      />
                      {exam.isNormalPackage === "1" && (
                        <p
                          style={{
                            color: "#333",
                            fontSize: "14px",
                            lineHeight: "1.5",
                            marginBottom: "10px",
                            flex: "1 1 auto",
                            overflow: "hidden",
                          }}
                          dangerouslySetInnerHTML={{ __html: exam.syllabus }}
                        />
                      )}
                      {exam.quid && exam.isNormalPackage === "1" && (
                        <div
                          style={{
                            marginTop: "auto",
                            paddingTop: "10px",
                            flex: "0 0 auto",
                          }}
                        >
                          <a
                            href={`${commonData.app}/${websiteId}/exam-link/${exam.quid}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              backgroundColor: "#ffd700",
                              color: "#000",
                              padding: "10px 20px",
                              textDecoration: "none",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              border: "2px solid #000",
                              boxShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                              transition: "all 0.3s ease",
                              width: "100%",
                              textAlign: "center",
                              boxSizing: "border-box",
                            }}
                          >
                            Start Exam
                          </a>
                        </div>
                      )}
                      {exam.quid && exam.isNormalPackage === "2" && (
                        <div
                          style={{
                            marginTop: "auto",
                            paddingTop: "10px",
                            flex: "0 0 auto",
                          }}
                        >
                          <a
                            href={`${
                              commonData.app
                            }/payumoney/payment/checkout/${packageData.gid}${
                              packageData.bucket !== "0"
                                ? "/aG9tZQ=="
                                : "/" + window.btoa(packageData.bucket)
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              backgroundColor: "#ffd700",
                              color: "#000",
                              padding: "10px 20px",
                              textDecoration: "none",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              border: "2px solid #000",
                              boxShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                              transition: "all 0.3s ease",
                              width: "100%",
                              textAlign: "center",
                              boxSizing: "border-box",
                            }}
                          >
                            Download PDF
                          </a>
                        </div>
                      )}
                      {exam.quid && exam.isNormalPackage === "3" && (
                        <div
                          style={{
                            marginTop: "auto",
                            paddingTop: "10px",
                            flex: "0 0 auto",
                          }}
                        >
                          <a
                            href={`${
                              commonData.app
                            }/payumoney/payment/checkout/${packageData.gid}${
                              packageData.bucket !== "0"
                                ? "/aG9tZQ=="
                                : "/" + window.btoa(packageData.bucket)
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              backgroundColor: "#ffd700",
                              color: "#000",
                              padding: "10px 20px",
                              textDecoration: "none",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              border: "2px solid #000",
                              boxShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                              transition: "all 0.3s ease",
                              width: "100%",
                              textAlign: "center",
                              boxSizing: "border-box",
                            }}
                          >
                            Watch Video
                          </a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="cta-container"
                style={{
                  display: "flex",
                  marginTop: "20px",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "40px",
                  flexWrap: "wrap",
                }}
              >
                <a
                  className="cta-link"
                  href={`${commonData.app}/payumoney/payment/checkout/${
                    packageData.gid
                  }${
                    packageData.bucket !== "0"
                      ? "/aG9tZQ=="
                      : "/" + window.btoa(packageData.bucket)
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    flex: "1 1 auto",
                    maxWidth: "300px",
                    minWidth: "250px",
                  }}
                >
                  <img
                    src="/batch-link.jpg"
                    alt="Payment link"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "6px",
                      borderColor: "white",
                      borderWidth: "1px",
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                      transition: "transform 0.3s ease",
                      cursor: "pointer",
                      border: "2px solid white",
                      padding: "6px",
                    }}
                  />
                </a>
                <a
                  className="cta-link"
                  href={packageData.whatsappGroup}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    flex: "1 1 auto",
                    maxWidth: "300px",
                    minWidth: "250px",
                  }}
                >
                  <img
                    src="/whatsapp-banner.jpg"
                    alt="WhatsApp Group link"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "6px",
                      borderColor: "white",
                      borderWidth: "1px",
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                      transition: "transform 0.3s ease",
                      cursor: "pointer",
                      border: "2px solid white",
                      padding: "6px",
                    }}
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TodayExams;
